import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

export default function LightWeight() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.LightWeight');
    const { locale } = useRouter();

    const IMGS_MAP2: any = {
        us: {
            img_1: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1731921142606/125w_weight.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1731924391204/125w_weight_h5.jpg',
            },
            img_2: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1731921142216/125w_weight_1.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1732098890769/125w_weight_1_h5.jpg',
            },
            img_3: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1731921142345/125w_weight_2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1731924390004/125w_weight_2_h5.jpg',
            },

            img_4: {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1731921142812/125w_weight_3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1731924390320/125w_weight_3_h5.jpg',
            },
        },
    };

    const IMGS = IMGS_MAP2[locale] || IMGS_MAP2.us;

    return (
        <div className={`${styles.TheComp} sp-125w-common`}>
            <EfSpec />
            <div className="info">
                <p className="title">{t('title')}</p>
                <p className="desc">
                    {t.rich('desc', {
                        sup: (text: string) => <sup>{text}</sup>,
                    })}
                </p>
            </div>
            <div className="light-weight-imgs-box">
                <div className="img-box">
                    <EFPicture src={IMGS?.img_1?.pc} srcPad={IMGS?.img_1?.h5} srcMobile={IMGS?.img_1?.h5} />
                </div>
            </div>
            <div className="light-weight-grids">
                <div className="grid-img-item img-item-1">
                    <div className="grid-img-info">
                        <div className="grid-text-content">
                            <div className="grid-text-title center-title">
                                {t('grid_title_1_1')}
                                <p className="grid-text-desc">{t('grid_desc_1_1')}</p>
                                <p className="grid-text-desc">{t('grid_desc_1_2')}</p>
                                <p className="grid-text-desc">{t('grid_desc_1_3')}</p>
                            </div>
                            <div className="grid-text-title center-title">
                                {t('grid_title_1_2')}
                                <p className="grid-text-desc">{t('grid_desc_2_1')}</p>
                            </div>
                        </div>
                        <div className="img-box">
                            <EFPicture src={IMGS?.img_2?.pc} srcPad={IMGS?.img_2?.h5} srcMobile={IMGS?.img_2?.h5} />
                        </div>
                    </div>
                </div>
                <div className="grid-img-item img-item-2">
                    <p className="grid-text-content grid-text-title">{t('grid_title_2')}</p>
                    <div className="img-box">
                        <EFPicture src={IMGS?.img_3?.pc} srcPad={IMGS?.img_3?.h5} srcMobile={IMGS?.img_3?.h5} />
                    </div>
                </div>
                <div className="grid-img-item img-item-3">
                    <p className="grid-text-content grid-text-title">{t('grid_title_3')}</p>
                    <div className="img-box">
                        <EFPicture src={IMGS?.img_4?.pc} srcPad={IMGS?.img_4?.h5} srcMobile={IMGS?.img_4?.h5} />
                    </div>
                </div>
            </div>
        </div>
    );
}
